import Cookies from "js-cookie";

const USER_DATA = "user-data";
const USER_TOKEN = "user-token";
// Note: REFRESH_TOKEN is now handled by HTTP-only cookies set by the backend

export const saveUserOnCookie = (userData, changeToken = true) => {
  localStorage.setItem(USER_DATA, JSON.stringify({ user: userData.user }));

  if (changeToken) {
    Cookies.set(USER_TOKEN, userData.token, {
      expires: 1, // 1 day for access token
      sameSite: "strict",
      // secure: true,
    });

    // Note: Refresh token is now set as HTTP-only cookie by the backend
    // No need to handle it client-side
  }
};

export const deleteUserOnCookie = () => {
  Cookies.remove(USER_TOKEN, { sameSite: "strict" });
  // Note: HTTP-only refresh token will be cleared by backend logout endpoint
  localStorage.removeItem(USER_DATA);
};

export const getUserFromCookie = () => {
  const jsonUserToken = Cookies.get(USER_TOKEN);

  if (jsonUserToken === undefined) return null;

  return {
    ...JSON.parse(localStorage.getItem(USER_DATA)),
    token: jsonUserToken,
    // Note: refreshToken is no longer accessible client-side
    // It will be automatically sent with requests to the backend
  };
};

// This function is no longer needed since refresh token is HTTP-only
// export const getRefreshToken = () => {
//   return Cookies.get(REFRESH_TOKEN);
// };

export const updateTokens = (token) => {
  if (token) {
    Cookies.set(USER_TOKEN, token, {
      expires: 1,
      sameSite: "strict",
      // secure: true,
    });
  }

  // Note: Refresh token updates are handled by the backend
  // and set as HTTP-only cookies
};
